// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__29sSo","tab":"Tabs_tab__1Pwcs","tabActive":"Tabs_tabActive__nHljw"};